import { Flex } from "Element/Flex";
import styled, { keyframes } from "styled-components";

export const LoadingWrapper = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const dots = keyframes`
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: #000;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 #000,
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0 #000,
      .5em 0 0 #000;}
`;

export const Loader = styled.h1`
  ${({ theme }) => theme.fontStyle.primaryBold}
  margin: 8px 0px;
  ::after {
    content: ".";
    animation: ${dots} 1s steps(5, end) infinite;
  }
`;

const float = keyframes`
0% {
		/* box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6); */
		transform: translatey(0px);
	}
	50% {
		/* box-shadow: 0 25px 15px 0px rgba(0,0,0,0.2); */
		transform: translatey(-20px);
	}
	100% {
		/* box-shadow: 0 5px 15px 0px rgba(0,0,0,0.6); */
		transform: translatey(0px);
	}
`;

export const UfoImg = styled.img`
  width: 96px;
  animation: ${float} 3s ease-in-out infinite;
`;
